import { Component, EventEmitter, Input, Output, ViewChild, } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpService } from '../../../http.service';
import { DxButtonModule, DxFormComponent, DxFormModule } from 'devextreme-angular';
import { Merchant, TopupMerchantAccount } from '../../home/models';
import notify from 'devextreme/ui/notify';
import { DataServiceService } from '../../../services/data-service.service';
import { CommonModule } from '@angular/common';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { DxoFormComponent } from 'devextreme-angular/ui/nested';
import { KeycloakService } from 'keycloak-angular';
import { style } from '@angular/animations';
import { getSizeQualifier, ScreenService } from '../../../services';
import { UtilityFunctions } from '../../../shared/helpers/utility-functions';
import { MerchantGridRecord } from '../../../components/utils/models/MerchantGridRecord';
import { ODataMerchant } from '../../../components/utils/models/ODataMerchant';
import { catchError, Observable, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

interface FormLayout {
  fee: number,
  merchantId: number,
  amount: number
}

@Component({
  standalone: true,
  imports: [ReactiveFormsModule, DxButtonModule, DxFormModule, CommonModule],
  selector: 'app-topup-merchant-account',
  templateUrl: './topup-merchant-account.component.html',
  styleUrl: './topup-merchant-account.component.scss'
})
  
export class TopupMerchantAccountComponent {
  @Input() colCount: number = 2;
  getSizeQualifier = getSizeQualifier;
  formData: FormLayout = {
    fee: 0,
    amount: 0,
    merchantId: -1
  };

  merchantsDataSource: any;
  merchant: any;
  priceListData: any;
  merchantList: any;
  UserKeycloakGuidId : any;
  formValid = false;
  merchantSelected = false;
  @ViewChild('formRef', { static: false }) merchantAccForm!: DxFormComponent;
  @Output() OnMerchantBalanceUpdate = new EventEmitter<number>();

  constructor(private httpService: HttpService, private dataService: DataServiceService, private keycloakService : KeycloakService, public screen: ScreenService) {
    this.merchantsDataSource = dataService.getQuickActionsMerchantDataSource();
    this.initData();
    this.keycloakService
        .loadUserProfile()
        .then(e => {
          this.UserKeycloakGuidId = e.id!;
        });

  }

  submitButtonOptions: DxButtonTypes.Properties = {
    text: 'Submit',
    type: 'default',
    useSubmitBehavior: true,
    width:120,
    elementAttr : {
      style : "margin-top:8px; width:120px;",

    },
    disabled: false
  };

  initData() {
    this.merchantSelected = false;
    this.formData.amount = 0;
    this.formData.fee = 0;
    this.merchantsDataSource.load().then(data => {
      this.merchantList = data;
      this.merchantList = this.merchantList.sort((a, b) => {
        
        return a.CompanyName.localeCompare(b.CompanyName)
      });
    }).catch(error => {
      console.error('Error loading data', error);
    });
  }


  onFormSubmit = (e: SubmitEvent) => {
    this.submitButtonOptions.disabled = true;

    var validationResult = this.merchantAccForm.instance.validate();
    if (validationResult.isValid!) {
      let data = new TopupMerchantAccount(this.formData.merchantId, this.formData.amount, this.formData.fee, this.UserKeycloakGuidId);
      this.httpService.topupMerchantAccount(data)
        .pipe(catchError((error: HttpErrorResponse, caught: Observable<any>): Observable<any> => {
        UtilityFunctions.showErrorMessage(error);
        return of();
      }))
      .subscribe(res => {
        UtilityFunctions.showMessage("Merchant account has successfully been topped up.", "success");
        this.OnMerchantBalanceUpdate.emit(data.amount);
        this.resetFormFields();
        this.submitButtonOptions.disabled = false;
      });
      
    } else {
      UtilityFunctions.showMessage("Form is invalid", "error");
    }
    e.preventDefault();
  };

  onFieldChange(fieldName?, value?, event?: any) {
    var validationResult = this.merchantAccForm.instance.validate();
    this.formValid = validationResult.isValid!;
    if (event?.dataField == "merchantId") {
      if (event.value) {
        this.httpService.getPricelistByMerchant(event.value).subscribe(res => {
          this.priceListData = res;
          this.formData.amount = 0;
          this.formData.fee = 0;
          this.merchantSelected = true;
        });
      }
      
    }
    if (event?.dataField == "amount") {

      // TODO: thanks Dovi for highlighting this, we should not be transacting on a Merchant if there is outstanding configs such as pricelists/rates for fees
      this.formData['fee'] = event.value * (this.priceListData != null ? this.priceListData.rate : 0);
    }
  }

  resetFormFields(){
    this.merchantAccForm.instance.reset()
    this.initData();
  }
}
